import { MESSAGE_TYPES } from '../../../../src/shared/constants';
import { SYSTEM_MESSAGE_TYPES } from '../../constants';
import { cleanObjectProperties } from '../../utils/clean-object-properties';

/**
 * @param {CreateTranslatedSystemMessagePayload} payload
 * @returns {CreateTranslatedSystemMessage}
 */
export const createTranslatedSystemMessage = ({ intlKey, intlValues, timestamp, type }) => ({
  messageType: MESSAGE_TYPES.SYSTEM,
  timestamp,
  intlKey,
  intlValues,
  type
});

/**
 * @param {CreateOperatorMessagePayload} payload
 * @returns {CreateOperatorMessage}
 */
export const createOperatorMessage = (payload) => {
  const message = {
    id: payload.line_id,
    messageType: MESSAGE_TYPES.FROM_OPERATOR,
    message: payload.message,
    operator: {
      first_name: '',
      last_name: '',
      avatar: '',
      ...payload.operator
    },
    operator_id: payload.operator_id,
    timestamp: convertTimestampToMs(payload.timestamp),
    translated_message: payload.translated_message,
    translation_status: payload.translation_status
  };

  return cleanObjectProperties(message, undefined);
};

/**
 * @param {CreateUserMessagePayload} payload
 * @returns {CreateUserMessage}
 */
export const createUserMessage = (payload) => ({
  id: payload.id,
  message: payload.message,
  messageType: MESSAGE_TYPES.FROM_USER,
  fe_ts: payload.fe_ts,
  timestamp: convertTimestampToMs(payload.timestamp),
  messageStatus: 'confirmed'
});

export const createMessage = (payload) => {
  const {
    is_service,
    operator,
    message,
    timestamp
  } = payload;

  if (is_service) {
    return {
      message: message,
      messageType: MESSAGE_TYPES.SYSTEM,
      timestamp: convertTimestampToMs(timestamp),
      type: SYSTEM_MESSAGE_TYPES.INSTRUCTION
    };
  }

  if (operator) {
    return createOperatorMessage(payload);
  }

  return createUserMessage(payload);
};

export const createMessageAttempt = ({ message, fe_ts }) => {
  return {
    message: message,
    messageType: MESSAGE_TYPES.FROM_USER,
    messageStatus: 'pending',
    fe_ts
  };
};

export const convertTimestampToMs = (timestamp) => timestamp * 1000;
